var render = function render(_c,_vm){return _c('transition',{attrs:{"name":"fade","appear":""}},[_c('div',{staticClass:"preloader",class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle])},[_c('div',{staticClass:"preloader__circle"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }